const RECALL_DELAY_TIME = 3;
export {
  RECALL_DELAY_TIME
};
